module.exports = global["$"] = require("-!/tmp/build_d64f13dc/node_modules/expose-loader/index.js?jQuery!./jquery.js");